// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Equation_wrapper__PnHbH","remainderPhrase":"Equation_remainderPhrase__onnbM","remainderDigit":"Equation_remainderDigit__8BcBv"};